<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Complete Dosage",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      test: "",
      title: "Complete Dosage",
      items: [
        {
          text: "Home",
        },
        {
          text: "Pharmacy Section",
        },
        {
          text: "Incomplete Dosage",
        },
        {
          text: "complete",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.serviceName",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "itemQty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],

      // Value from user input for adding position
      data: {
        item: "",
        quantity: "",
        unit_price: "",
        visit_id:this.$route.params.visit_id
      },
      populate: {
        item: "",
        quantity: "",
        unit_price: "",
      },
      itemError: "",
      quantityError: "",

      modeError: "",
      paidError: "",
      customerError: "",

      quantitydiffError: "",

      totals: {
        paid: "",
        mode: "",
        customer: "",
        customer_phone: "",
        total: "",
      },
      // edit item
      editdata: {
        id: "",
        item: "",
        name: "",
        quantity: "",
        price: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("sales", ["total_cart", "saleId"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("payments", ["PaymentModes"]),
    ...mapGetters("visits", ["visit_patient"]),
    ...mapGetters("sales", [
      "AddState",
      "SaveState",
      "VisitIncompleteDosageItems",
      "SaleCart",
      "TotalCart",
      "PharmacyStock",
      "SalesId",
    ]),

    /**
     * Total no. of records
     */

    rows() {
      return this.SaleCart ? this.SaleCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    this.totals.paid = this.TotalCart.total;
    this.totals.total = this.TotalCart.total;
    // Set the initial number of items
    this.totalRows = this.SaleCart ? this.SaleCart.length : 1;
  },
  watch: {
    saleId(newValue) {
      if (newValue != "") {
        window.open(
          `https://${window.location.host}/preciept/salereceipt.php?id=${btoa(newValue)}`
        );
     
      }
    },
    visit_patient(newValue){
           if (newValue != "") {
      this.title = `Complete Dosage FOR ${this.visit_patient.patient.patient_name}`
                        }
                        },
    
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.resetData();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    total_cart(newValue) {
      if (newValue) {
        this.totals.paid = this.TotalCart.total;
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCart: "sales/fetchCart",
      FetchVisitPatientProfile: "visits/fetchVisitPatientProfile",
      FetchModes: "payments/fetchPaymentModes",
      FetchItem: "sales/fetchPharmacyItems",
      AddCart: "sales/addToCart",
      DeleteCartItem: "sales/deleteCart",
      FetchTotal: "sales/fetchTotCart",
      EditCartItems: "sales/editCart",
      ProcessSale: "sales/saveSale",
      FetchVisitIncompleteDosageItem: "sales/fetchVisitIncompleteDosageItem",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkItem() {
      if (this.data.item != "") {
        this.existingItem = this.SaleCart.filter((item) => {
          return item.item.id == this.data.item;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.item = "";
      this.data.unit_price = "";
      this.data.quantity = "";
    },

    checkqty() {
      if (parseInt(this.data.quantity) > parseInt(this.populate.quantity)) {
        this.quantityError = "Quantity Sold is greater than quantity in stock";
      } else {
        this.quantityError = "";
      }
    },

    populateFields() {
      let filtered_item = this.PharmacyStock.filter((element) => {
        return element.id == this.data.item;
      });
      let ob_item = filtered_item[0];
      this.populate.unit_price = ob_item.sellingPrice;
      this.populate.quantity = ob_item.inStock;
      this.data.unit_price = ob_item.sellingPrice;
    },

    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.name = "";
      this.editdata.item = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.price = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
    },
    resetSaleErrors() {
      this.paidError = "";
      this.modeError = "";
      this.customerError = "";
    },

    showEditModal(data) {
      this.editdata.name = data.item.serviceName;
      this.editdata.item = data.item.id;
      this.editdata.id = data.id;
      this.editdata.quantity = data.itemQty;
      this.editdata.price = data.unitPrice;
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.serviceName;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveSale() {
      if (this.totals.paid < this.totals.total && this.totals.customer == "") {
        this.customerError = "Customer is Required";
        return;
      } else {
        this.customerError = "";
      }
      if (this.totals.paid == "") {
        this.paidError = "Amount Paid is Required";
        return;
      } else {
        this.paidError = "";
      }
      if (this.totals.mode == "") {
        this.modeError = "Payment Method is Required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.quantityError != "") {
        return;
      }
      this.ProcessSale(this.totals);
    },
    addToCart() {
      if (this.data.item == "") {
        this.itemError = "Item Field is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity Field is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchItem();
    this.FetchCart();
    this.FetchTotal();
    this.FetchModes();
    this.FetchVisitIncompleteDosageItem(this.$route.params.visit_id);
    this.FetchVisitPatientProfile(this.$route.params.visit_id);
  },
  updated() {
    this.totals.total = this.TotalCart.total;
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-8"><h4 class="card-title">Items in Cart</h4></div>
            
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
 
            <!-- Table -->
            <div class="table-responsive mb-0">
            
              <b-table
                class="datatables"
                :items="SaleCart ? SaleCart : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitPrice
                      ? thousandSeprator(data.item.unitPrice * data.item.itemQty)
                      : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.unitPrice ? thousandSeprator(data.item.unitPrice) : 0 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-item-modal
                    class="m-2"
                    @click="showEditModal(data.item)"
                    >Edit</b-button
                  >
                  <b-button
                    v-b-modal.delete-item-modal
                    variant="danger"
                    size="sm"
                    @click="showDeleteModal(data.item)"
                    >Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!SaleCart" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row" v-if="TotalCart.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                    >TOTAL:
                    {{
                      TotalCart.total ? thousandSeprator(TotalCart.total) : 0
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>
            <b-form v-if="TotalCart.total > 0">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Amount Paid</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="totals.paid"
                      @input="resetSaleErrors()"
                    />
                  </div>
                  <div class="text-danger" v-if="paidError">
                    <em>{{ paidError }}</em>
                  </div>
                  <div class="form-group">
                    <label>Payment Method</label>
                    <model-list-select
                      :list="PaymentModes ? PaymentModes : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetSaleErrors()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                  <div class="form-group" v-if="totals.paid < totals.total">
                    <label>Customer Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.customer"
                      @input="resetSaleErrors()"
                      placeholder="Enter Customer Name"
                    />
                  </div>
                  <div class="text-danger" v-if="customerError">
                    <em>{{ customerError }}</em>
                  </div>
                  <div class="form-group" v-if="totals.paid < totals.total">
                    <label>Customer Phone</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model="totals.customer_phone"
                      placeholder="Enter Customer Phone"
                    />
                  </div>
                </div>
                <div class="col-12 mt-4" align="center">
                  <b-button variant="primary" @click="saveSale()"
                    ><i class="fa fa-check"></i> Process Order
                    <b-spinner
                      v-if="SaveState"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="card">
          <div class="card-body">
         
            <h4 class="card-title mb-4">Add To Cart</h4>
            <b-form @submit.prevent="addToCart()">
              <div class="form-group mb-3">
                <label>Item To Sell</label>
                <model-list-select
                  :list="VisitIncompleteDosageItems ? VisitIncompleteDosageItems : []"
                  v-model="data.item"
                  option-value="id"
                  option-text="drug_name"
                  placeholder="Select Item"
                  @input="resetErrors(), populateFields(), checkItem()"
                >
                </model-list-select>
                <small><i>Only Items in stock appear here</i></small>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Selling Price</label>
                <input
                  type="text"
                  class="form-control"
                  step="any"
                  v-model="data.unit_price"
                  placeholder="Unit Price"
                  readonly
                />
                <small><i>Selling Price for each unit</i></small>
              </div>
              <div class="form-group mb-3">
                <label>Quantity To Sell</label>
                <input
                  type="number"
                  class="form-control"
                  step="any"
                  v-model="data.quantity"
                  @input="resetErrors(), checkqty()"
                  @keyup.enter="addToCart()"
                  placeholder="Enter Quantity"
                />
                <small class="success"
                  ><i>Quantity in stock</i> =
                  {{ this.populate.quantity ? this.populate.quantity : "--" }}</small
                >
                <div class="text-danger" v-if="quantityError">
                  <em>{{ quantityError }}</em>
                </div>
              </div>
              <div class="form-group text-center">
                <b-button
                  v-if="user_permissions.make_sale"
                  @click="addToCart()"
                  variant="primary"
                  ><i class="fa fa-plus"></i> Add
                  <b-spinner
                    v-if="AddState"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" hide-footer @hidden="resetEdit()">
      <template #modal-title class="text-primary">
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Item</label>
        <model-list-select
          :list="PharmacyStock ? PharmacyStock : []"
          v-model="editdata.item"
          option-value="id"
          option-text="drug_name"
          placeholder="Select Role"
        >
        </model-list-select>
      </div>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
          type="number"
          class="form-control"
          step="any"
          v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input type="number" class="form-control" step="any" v-model="editdata.price" />
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner v-if="AddState" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" hide-footer @hidden="resetDeleteItem">
      <template #modal-title class="text-danger">
        Remove <strong>{{ deletedata.name }}</strong> From Cart</template
      >
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="AddState" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>

<style scoped>
.success {
  font-size: 17px;
  color: rgb(9, 156, 87);
}
</style>
